/* unplugin-vue-components disabled */import { render } from "./Head.vue?vue&type=template&id=7a4f3310&scoped=true"
import script from "./Head.vue?vue&type=script&lang=js"
export * from "./Head.vue?vue&type=script&lang=js"

import "./Head.vue?vue&type=style&index=0&id=7a4f3310&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户四川护理-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4f3310"]])

export default __exports__